export { LocationTypeApiClient, locationTypeApiClient } from './location-types-api';
